<div class="h-2.5 w-full rounded-full bg-grey-lightGrey">
  <div class="h-2.5 rounded-full bg-orange" [style.width.%]="percentage"></div>
</div>
